import React, { useState,useEffect } from "react";
import { Alert, Button } from "react-bootstrap";
import "./alert.css";

const AlertDismissible = (props) => {
  const [show, setShow] = useState(props.show);
  const [reload, setReload] = useState(props.reload);

  /* useEffect(()=>{
    setShow(props.show)
  },[show])
 */
  const setVal = () => {
    setShow(false);

    if (reload) window.location.reload();

    props.parentCallback();
  };

  return (
    <>
      <div className="alert-size">
        <Alert show={show} variant="danger">
          <Alert.Heading>{props.message}</Alert.Heading>
          <div className="d-flex justify-content-end">
            <Button onClick={setVal} variant="outline-danger">
              ok
            </Button>
          </div>
        </Alert>
      </div>
    </>
  );
};

export default AlertDismissible;